import React from 'react'
import { Tent, Calendar, Route, Trophy, TrainTrack, Bike, Navigation } from 'lucide-react'
import { renderToString } from 'react-dom/server'
import { getRouteTypeDisplay } from './routeDisplay'

// Icon mapping for route types
export const getRouteIcon = (routeType: string): string => {
  const iconComponent = (() => {
    switch (routeType) {
      case 'Bikepacking':
        return <Tent size={10} stroke="white" strokeWidth={2.5} />
      case 'Event':
        return <Calendar size={10} stroke="white" strokeWidth={2.5} />
      case 'Single Route':
        return <Route size={10} stroke="white" strokeWidth={2.5} />
      case 'Permanent':
        return <Trophy size={10} stroke="white" strokeWidth={2.5} />
      case 'Rail Trail':
        return <TrainTrack size={10} stroke="white" strokeWidth={2.5} />
      case 'Bike Path':
        return <Bike size={10} stroke="white" strokeWidth={2.5} />
      case 'Bike Path Route':
        return <Navigation size={10} stroke="white" strokeWidth={2.5} />
      default:
        return <Route size={10} stroke="white" strokeWidth={2.5} />
    }
  })()
  
  return renderToString(iconComponent)
}

export const createMarkerElement = (routeId: string, routeType: string): HTMLDivElement => {
  const markerElement = document.createElement('div')
  markerElement.className = 'route-marker'
  markerElement.setAttribute('data-route-id', routeId)
  markerElement.innerHTML = `
    <div class="marker-container" style="
      position: relative;
      width: 24px;
      height: 30px;
      cursor: pointer;
      transition: transform 0.2s ease;
    ">
      <div class="marker-pin" style="
        width: 24px;
        height: 24px;
        background: linear-gradient(135deg, rgba(0,0,0,0.3) 0%, rgba(31,41,55,0.35) 100%);
        backdrop-filter: blur(1px);
        -webkit-backdrop-filter: blur(1px);
        border: 1.5px solid rgba(255,255,255,0.04);
        border-radius: 50% 50% 50% 0;
        transform: rotate(-45deg);
        box-shadow: 0 4px 12px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.025);
        position: absolute;
        top: 0;
        left: 0;
        transition: all 0.2s ease;
      "></div>
      <div class="marker-icon" style="
        position: absolute;
        top: 7px;
        left: 7px;
        z-index: 2;
        transition: all 0.2s ease;
      ">
        ${getRouteIcon(getRouteTypeDisplay(routeType))}
      </div>
    </div>
  `
  return markerElement
}